import gsap from 'gsap'
import SplitText from '../assets/lib/SplitText'
import { lerp } from '@/scripts/utils'

import eventBus from '@/scripts/event-bus';

const animations = new Map()

animations.set('top', (el) => {
  const tl = new gsap.TimelineMax()

  tl
    .from(el, 2, {
      y: 20,
      autoAlpha: 0,
      ease: gsap.Expo.easeOut,
      clearProps: 'transform, visibility, opacity'
    })
})

animations.set('fade', (el) => {
  gsap.from(el, 1.2, {
    autoAlpha: 0,
    delay: 0.3,
    ease: gsap.Power2.easeOut,
    clearProps: 'all'
  })
})

animations.set('title', (el) => {
  const tl = new gsap.TimelineMax()
  const split = new SplitText(el, { type: 'words, chars', linesClass: 'lines' })

  tl
    .staggerFrom(split.chars, 1.2, {
      yPercent: 60,
      rotationZ: 20,
      rotationY: 80,
      autoAlpha: 0,
      delay: 0.3,
      ease: gsap.Expo.easeInOut
    }, 0.03)
    .add(() => split.revert())
})

animations.set('stagger', (el) => {
  let delay = 0.4;
  const split = new SplitText(el, { type: 'lines', linesClass: 'lines' })
  const tl = new gsap.TimelineMax({
    onStart: () => el.setAttribute('data-animated', ''),
    onComplete: () => {
      split.revert();
      el.setAttribute('data-light', '');
    }
  })

  if (el.hasAttribute('data-stagger')) {
    delay += el.getAttribute('data-stagger') * 0.4
  }

  tl
    .to(el, 0.01, { autoAlpha: 1 })
    .staggerFrom(split.lines, 0.7, {
      yPercent: 75,
      autoAlpha: 0,
      delay,
      ease: gsap.Power2.easeOut
    }, 0.05)
    // .add(() => split.revert())
})

animations.set('staggerVue', (el) => {
  let delay = 0.4;
  const split = new SplitText(el, { type: 'lines', linesClass: 'lines' })
  const tl = new gsap.TimelineMax({
    onStart: () => el.setAttribute('data-animated', ''),
    onComplete: () => {
      el.setAttribute('data-light', '');
    }
  })

  if (el.hasAttribute('data-stagger')) {
    delay += el.getAttribute('data-stagger') * 0.4
  }

  tl
    .staggerFrom(split.lines, 0.7, {
      yPercent: 75,
      autoAlpha: 0,
      delay,
      ease: gsap.Power2.easeOut
    }, 0.05)
    // .add(() => split.revert())
})

animations.set('staggerImg', (el) => {
  const images = Array.from(el.querySelectorAll('img'))
  const tl = new gsap.TimelineMax()

  tl
    .staggerFrom(images, 0.7, {
      yPercent: 75,
      autoAlpha: 0,
      delay: 0.4,
      ease: gsap.Power2.easeOut
    }, 0.05)
})

animations.set('mask', (el) => {
  const tl = new gsap.TimelineMax()

  tl
    .to(el, 1.5, {
      scaleY: 1,
      transformOrigin: '50% 0',
      delay: 0.6,
      ease: gsap.Power2.easeOut
    })
})

animations.set('explode', (el) => {
  const image = el.querySelector('div')
  const tl = new gsap.TimelineMax({ delay: 0.4, onComplete: () =>{
    eventBus.$emit('explode!');
  } })

  tl.fromTo(el, 1, {
    autoAlpha: 0,
  },{
    autoAlpha: 1,
    clearProps: 'autoAlpha',
  })
})

animations.set('bg', (color, dir) => {
  gsap.to(document.body, 1.5, {
    onStart: () => {
      if (dir) {
        document.body.setAttribute('data-animated', true)
      } else {
        document.body.removeAttribute('data-animated')
      }
    },
    backgroundColor: color,
    ease: gsap.Power2.easeOut
  })
})

const offsets = []
animations.set('parallax', (el, i) => {
  const bound = el.parentElement.getBoundingClientRect().top
  const image = el.querySelector('div')
  let final = 1

  if (!el.getAttribute('data-animated')) {
    el.setAttribute('data-animated', true)
    offsets[i] = bound
  }

  const parallaxAttr = el.getAttribute('data-parallax')
  const elH = el.parentElement.clientHeight
  const relativity = parallaxAttr === 'relative' ? offsets[i] : ((window.innerHeight - elH) / 2)
  const offsetTop = bound - relativity
  const coefficent = parallaxAttr !== null && parallaxAttr !== 'relative' ? parallaxAttr : 0.2
  const maxY = Math.max(-window.innerHeight, offsetTop)
  const baseTransform = Math.floor(Math.min(window.innerHeight, maxY), 2)
  const translateY = baseTransform * parseFloat(coefficent)

  final = lerp(final, translateY, 1)
  gsap.set(el, { y: final })
  // if (image !== null) gsap.set(image, { scale: 1 + Math.abs(translateY / (elH * 0.2)) })
})

export default animations



// WEBPACK FOOTER //
// ./src/scripts/animations.js